import { Store } from "@/zustand/store";
import { StateCreator } from "zustand";

export type SelectedItemsSlice = {
  tariffId: number | undefined;
  productId: number | undefined;
  changeTariff: (tariffId: number | undefined) => void;
  changeProduct: (productId: number | undefined) => void;
};

const initialData = {
  tariffId: undefined,
  productId: undefined,
};

export const createSelectedItemsSlice: StateCreator<
  Store,
  [],
  [],
  SelectedItemsSlice
> = (set) => ({
  ...initialData,
  changeTariff: (tariffId) => set({ tariffId }),
  changeProduct: (productId) => set({ productId }),
});
